import React from 'react';

type DetailCardProps = {
    title: string;
    right?: React.ReactNode;
    children: React.ReactNode;
};

export function DetailCard(props: DetailCardProps): React.JSX.Element {
    const { title, right, children } = props;
    return (
        <div className="rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm transition-shadow hover:shadow-md overflow-hidden">
            <div className="border-b border-gray-200 dark:border-slate-700 bg-gradient-to-r from-sky-50 via-white to-white dark:from-slate-800 dark:via-slate-900 dark:to-slate-950 px-4 py-3 flex items-center justify-between">
                <div className="text-sm font-semibold tracking-tight text-gray-900 dark:text-slate-100">{title}</div>
                {right}
            </div>
            <div className="p-4">{children}</div>
        </div>
    );
}

export function DetailKeyValue({ k, v }: { k: string; v: React.ReactNode }): React.JSX.Element {
    return (
        <div className="flex items-start gap-3 py-1.5">
            <div className="w-36 shrink-0 text-xs font-medium text-gray-500 dark:text-slate-400">{k}</div>
            <div className="min-w-0 flex-1 text-xs text-gray-900 dark:text-slate-100 break-words">{v}</div>
        </div>
    );
}
